// extracted by mini-css-extract-plugin
export default {"ranger_accordeon":"AllAccordeonItem_ranger_accordeon__Gh7ml","accordeon_container":"AllAccordeonItem_accordeon_container__ZMoZP"};